<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg17.jpg" alt="" />
    <div class="activity-content">
      <div
        class="activity-btn"
        @click="goTopay(item)"
        :class="status != 2 ? 'default-btn' : ''"
        v-for="(item, index) in materialParamsDTO.materialParamsDetailDTOList"
        :key="index"
      >
        <div
          v-if="status == 1"
          style="display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动尚未开始
        </div>
        <div
          v-if="status == 0"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动已下线
        </div>
        <div
          v-if="status == 3"
          style=" display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动已结束
        </div>
        <div v-if="status == 2 && item.materialParamsDetailType == 1">
          <div>
            充<span>{{ item.rechargeMoney }}</span
            >多送<span>{{ item.giveAwayMoney }}</span>
          </div>
          <p>
            共得{{ item.totalbookCoin }}书币
          </p>
        </div>
        <div v-if="status == 2 && item.materialParamsDetailType == 2">
          <div>
            充<span>{{ item.rechargeMoney }}</span>
            <em v-if="item.giveAwayMember == 4">包年</em>
            <em v-if="item.giveAwayMember == 3">包半年</em>
            <em v-if="item.giveAwayMember == 2">包季</em>
            <em v-if="item.giveAwayMember == 1">包月</em>
            <em v-if="item.giveAwayMember == 0">包周</em>
          </div>
          <p>畅享所有图书</p>
        </div>
      </div>
      <div class="activity-tip">
        <p>活动规则</p>
        <p>
          1、活动时间：即日起至<span>{{ endTime }}</span
          >
        </p>
        <p>
          2、本次活动
          <span v-if="purchaseLimitDTO.purchaseLimitType == 2"
            >参与次数不限</span
          >
          <span v-if="purchaseLimitDTO.purchaseLimitType == 1"
            >每天仅限参与{{ purchaseLimitDTO.purchaseLimitValue }}次</span
          >
          <span v-if="purchaseLimitDTO.purchaseLimitType == 0"
            >每人仅限参与{{ purchaseLimitDTO.purchaseLimitValue }}次</span
          >
        </p>
        <p>3、此充值为书币充值，一经充值不支持退款</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status", "materialParamsDTO", "endTime", "purchaseLimitDTO"],
  data() { 
    return {};
  },
  watch: {
    materialParamsDTO: {
      handler: function (val) {
        console.log(val);
      },
      deep: true,
    },
    purchaseLimitDTO: {
      handler: function (val) {
        console.log(val);
      },
      deep: true,
    },
  },
  methods: {
    goTopay(item) {
      this.$emit("payActivity", item);
    },
  },
};
</script>
<style scoped>
em {
  font-style: initial;
}
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(209px + env(safe-area-inset-top));
}
.activity-btn {
  background-image: url('../../../../static/model-btn14.png');
  width: 318px;
  height: 92px;
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
  background-size: cover;
  padding:16px 0px;
  box-sizing: border-box;
}
.activity-btn > div {
  font-size: 26px;
  color: #333333;
  height: 55px;
}
.activity-btn > div > div {
  line-height: 36px;
  font-weight: bold;
  letter-spacing: 1.04px;
}
.activity-btn > div > div > span {
  color: #D40000;
}
.activity-btn > div > p {
  font-size: 15px;
  color: #ffffff;
}
.default-btn {
  background-image: url('../../../../static/model-btns14.png');
}

.default-btn > div,
.default-btn > div > div > span,
.default-btn > div > p {
  color: #606060;
}
.activity-content > .activity-tip {
  text-align: left;
  width: 260PX;
  margin: 0 auto;
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 12px;
}
.activity-tip p {
  white-space: nowrap;
  font-size: 12px;
  color: #ffffff;
  line-height: 17px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modelseventeen.vue